import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "25",
  fill: "inherit"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M20.86 11.35q.13-.415.14-.85v-4c0-2.85-4.3-5-10-5S1 3.65 1 6.5v4a3.89 3.89 0 0 0 2.14 3.16 2.6 2.6 0 0 0-.14.84v4c0 2.85 4.3 5 10 5s10-2.15 10-5v-4a3.86 3.86 0 0 0-2.14-3.15M11 15.5c3.85 0 7.06-1 8.74-2.5.8.48 1.26 1 1.26 1.5 0 1.22-3.12 3-8 3s-7.91-1.73-8-2.95c1.93.66 3.96.98 6 .95m0-12c4.88 0 8 1.78 8 3s-3.12 3-8 3-8-1.78-8-3 3.12-3 8-3M3 9.56a14.93 14.93 0 0 0 8 1.94 14.93 14.93 0 0 0 8-1.94v.94c0 1.22-3.12 3-8 3s-8-1.78-8-3zM13 21.5c-4.88 0-8-1.78-8-3v-.94a14.93 14.93 0 0 0 8 1.94 14.93 14.93 0 0 0 8-1.94v.94c0 1.22-3.12 3-8 3" }, null, -1)
  ])))
}
export default { render: render }